/* tslint:disable */
/* eslint-disable */
/**
 * API
 * API
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { InlineObjectDto } from '../models';
// @ts-ignore
import type { LogPracticalExamSecurityEventRequestDto } from '../models';
/**
 * PracticalExamSecurityEventApi - axios parameter creator
 * @export
 */
export const PracticalExamSecurityEventApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Rejestruje zdarzenie anti-cheat na widoku zdającego egzaminu praktycznego. Zakres ograniczony do: COPY, PASTE, PRINT_SCREEN. Nieznane typy są ignorowane. 
         * @summary Log a security (anti-cheat) event during a practical exam (examinee side)
         * @param {number} certificationId 
         * @param {number} stageId 
         * @param {string} examId 
         * @param {LogPracticalExamSecurityEventRequestDto} logPracticalExamSecurityEventRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        logPracticalExamSecurityEvent: async (certificationId: number, stageId: number, examId: string, logPracticalExamSecurityEventRequestDto: LogPracticalExamSecurityEventRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'certificationId' is not null or undefined
            assertParamExists('logPracticalExamSecurityEvent', 'certificationId', certificationId)
            // verify required parameter 'stageId' is not null or undefined
            assertParamExists('logPracticalExamSecurityEvent', 'stageId', stageId)
            // verify required parameter 'examId' is not null or undefined
            assertParamExists('logPracticalExamSecurityEvent', 'examId', examId)
            // verify required parameter 'logPracticalExamSecurityEventRequestDto' is not null or undefined
            assertParamExists('logPracticalExamSecurityEvent', 'logPracticalExamSecurityEventRequestDto', logPracticalExamSecurityEventRequestDto)
            const localVarPath = `/api/v2/certifications/{certificationId}/stages/{stageId}/exam/exams/{examId}/security-events`
                .replace(`{${"certificationId"}}`, encodeURIComponent(String(certificationId)))
                .replace(`{${"stageId"}}`, encodeURIComponent(String(stageId)))
                .replace(`{${"examId"}}`, encodeURIComponent(String(examId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(logPracticalExamSecurityEventRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PracticalExamSecurityEventApi - functional programming interface
 * @export
 */
export const PracticalExamSecurityEventApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PracticalExamSecurityEventApiAxiosParamCreator(configuration)
    return {
        /**
         * Rejestruje zdarzenie anti-cheat na widoku zdającego egzaminu praktycznego. Zakres ograniczony do: COPY, PASTE, PRINT_SCREEN. Nieznane typy są ignorowane. 
         * @summary Log a security (anti-cheat) event during a practical exam (examinee side)
         * @param {number} certificationId 
         * @param {number} stageId 
         * @param {string} examId 
         * @param {LogPracticalExamSecurityEventRequestDto} logPracticalExamSecurityEventRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async logPracticalExamSecurityEvent(certificationId: number, stageId: number, examId: string, logPracticalExamSecurityEventRequestDto: LogPracticalExamSecurityEventRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.logPracticalExamSecurityEvent(certificationId, stageId, examId, logPracticalExamSecurityEventRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PracticalExamSecurityEventApi.logPracticalExamSecurityEvent']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * PracticalExamSecurityEventApi - factory interface
 * @export
 */
export const PracticalExamSecurityEventApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PracticalExamSecurityEventApiFp(configuration)
    return {
        /**
         * Rejestruje zdarzenie anti-cheat na widoku zdającego egzaminu praktycznego. Zakres ograniczony do: COPY, PASTE, PRINT_SCREEN. Nieznane typy są ignorowane. 
         * @summary Log a security (anti-cheat) event during a practical exam (examinee side)
         * @param {number} certificationId 
         * @param {number} stageId 
         * @param {string} examId 
         * @param {LogPracticalExamSecurityEventRequestDto} logPracticalExamSecurityEventRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        logPracticalExamSecurityEvent(certificationId: number, stageId: number, examId: string, logPracticalExamSecurityEventRequestDto: LogPracticalExamSecurityEventRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.logPracticalExamSecurityEvent(certificationId, stageId, examId, logPracticalExamSecurityEventRequestDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * PracticalExamSecurityEventApi - interface
 * @export
 * @interface PracticalExamSecurityEventApi
 */
export interface PracticalExamSecurityEventApiInterface {
    /**
     * Rejestruje zdarzenie anti-cheat na widoku zdającego egzaminu praktycznego. Zakres ograniczony do: COPY, PASTE, PRINT_SCREEN. Nieznane typy są ignorowane. 
     * @summary Log a security (anti-cheat) event during a practical exam (examinee side)
     * @param {number} certificationId 
     * @param {number} stageId 
     * @param {string} examId 
     * @param {LogPracticalExamSecurityEventRequestDto} logPracticalExamSecurityEventRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PracticalExamSecurityEventApiInterface
     */
    logPracticalExamSecurityEvent(certificationId: number, stageId: number, examId: string, logPracticalExamSecurityEventRequestDto: LogPracticalExamSecurityEventRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<void>;

}

/**
 * PracticalExamSecurityEventApi - object-oriented interface
 * @export
 * @class PracticalExamSecurityEventApi
 * @extends {BaseAPI}
 */
export class PracticalExamSecurityEventApi extends BaseAPI implements PracticalExamSecurityEventApiInterface {
    /**
     * Rejestruje zdarzenie anti-cheat na widoku zdającego egzaminu praktycznego. Zakres ograniczony do: COPY, PASTE, PRINT_SCREEN. Nieznane typy są ignorowane. 
     * @summary Log a security (anti-cheat) event during a practical exam (examinee side)
     * @param {number} certificationId 
     * @param {number} stageId 
     * @param {string} examId 
     * @param {LogPracticalExamSecurityEventRequestDto} logPracticalExamSecurityEventRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PracticalExamSecurityEventApi
     */
    public logPracticalExamSecurityEvent(certificationId: number, stageId: number, examId: string, logPracticalExamSecurityEventRequestDto: LogPracticalExamSecurityEventRequestDto, options?: RawAxiosRequestConfig) {
        return PracticalExamSecurityEventApiFp(this.configuration).logPracticalExamSecurityEvent(certificationId, stageId, examId, logPracticalExamSecurityEventRequestDto, options).then((request) => request(this.axios, this.basePath));
    }
}

